import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './switch.magic.css.js';
import script from './switch.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch",class:{
        'switch--right': _vm.right,
        'switch--inline': _vm.inline,
        'switch--two-state': _vm.twoState
    },attrs:{"part":_vm.$p('switch', {
        'switch--right': _vm.right,
        'switch--inline': _vm.inline,
        'switch--two-state': _vm.twoState
    })}},[_c('input',_vm._b({staticClass:"input",attrs:{"id":"input","part":"input","type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){$event.stopPropagation();return _vm.onChange($event.target.checked)}}},'input',_vm.$filteredAttrs,false)),_vm._v(" "),_c('label',{staticClass:"label",attrs:{"part":"label","for":"input"}},[(_vm.right)?_c('span',{staticClass:"inner",attrs:{"part":"inner"}},[_vm._t("default")],2):(_vm.twoState)?_c('span',{staticClass:"inner",attrs:{"part":"inner"}},[_vm._t("left"),_vm._v(" "),_vm._t("right")],2):_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6648a567_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-6648a567";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
